/**
 * React component for action button.
 * Icon button with tooltip and hotkey display.
 */

interface ActionButtonProps {
  label: string;
  hotkey?: string;
  onClick: () => void;
  tooltip?: string;
  active?: boolean;
  disabled?: boolean;
}

export default function ActionButton({
  label,
  hotkey,
  onClick,
  tooltip,
  active = false,
  disabled = false,
}: ActionButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`px-4 py-2 rounded transition-colors text-sm font-semibold relative ${
        disabled
          ? 'bg-gray-700 text-gray-400 cursor-not-allowed'
          : active
            ? 'bg-blue-600 text-white hover:bg-blue-700'
            : 'bg-black text-white hover:bg-gray-800'
      }`}
      title={tooltip || label}
      aria-label={tooltip || label}
    >
      <div className="flex items-center gap-2">
        <span>{label}</span>
        {hotkey && <span className="text-xs text-gray-400 font-normal">({hotkey})</span>}
      </div>
    </button>
  );
}
